import {
  WINDOW_RESIZE,
  OPEN_MODAL,
  CLOSE_MODAL,
  SIGNIN,
  SIGNIN_SUCCESS,
  SIGNIN_ERROR,
  SIGNOUT,
  REFRESH_TOKEN_SUCCESS,
  GET_ALL_USERS,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_ERROR,
  REQ_PWD_CHANGE,
  CHANGE_PWD_SUCCESS,
  CHANGE_PWD_ERROR,
} from "store/actions/index";

const init: any = {
  isMobile: false,
  windowWidth: window.innerWidth,
  modalOpen: false,
  modalMessage: "",
  user: {
    signedIn: false,
    error: false,
    reqPwdChange: false,
    data: {},
  },
  users: {
    error: false,
    isLoading: false,
    userList: [],
  },
};

const coreReducer = (state: any = init, action: any): any => {
  switch (action.type) {
    case WINDOW_RESIZE:
      return {
        ...state,
        windowWidth: window.innerWidth,
        isMobile: window.innerWidth <= 768,
      };
    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        //modal needs to be closed as if they create a mission but leave before the
        //close function is called it'll always pop up
        modalOpen: false,
        modalMessage: "",
      };
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true,
        modalMessage: action.payload,
      };
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false,
        modalMessage: "",
      };
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        user: {
          signedIn: true,
          error: false,
        },
      };
    case SIGNIN:
      return {
        ...state,
        user: {
          signedIn: false,
          error: false,
        },
      };
    case SIGNIN_SUCCESS:
      window.localStorage.cognitoKey = action.payload.keyPrefix;
      return {
        ...state,
        user: {
          signedIn: true,
          error: false,
        },
      };
    case SIGNIN_ERROR:
      return {
        ...state,
        user: {
          signedIn: false,
          error: true,
          data: { ...action.payload },
        },
      };
    case REQ_PWD_CHANGE:
      return {
        ...state,
        user: {
          ...state.user,
          reqPwdChange: true,
          userData: {
            ...action.payload,
          },
        },
      };
    case CHANGE_PWD_SUCCESS:
      return {
        ...state,
        user: {
          signedIn: true,
          error: false,
          reqPwdChange: false,
          data: {},
          userData: {},
        },
      };
    case CHANGE_PWD_ERROR:
      return {
        ...state,
        user: {
          ...state.user,
          error: true,
          data: { ...action.payload },
        },
      };
    case SIGNOUT:
      window.localStorage.clear();
      return {
        ...state,
        user: {
          signedIn: false,
          error: false,
          data: {},
        },
      };
    case GET_ALL_USERS:
      return {
        ...state,
        users: {
          error: false,
          isLoading: true,
          userList: [],
        },
      };
    case GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        users: {
          error: false,
          isLoading: false,
          userList: action.payload,
        },
      };
    case GET_ALL_USERS_ERROR:
      return {
        ...state,
        users: {
          error: true,
          isLoading: false,
          userList: [],
        },
      };
    default:
      return state;
  }
};

export default coreReducer;
